import React from 'react';
import ReactHint from 'react-hint';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import 'react-hint/css/index.css';
import styles from 'styles/components/lib/tables/statsTable.css';

class StatsTable extends React.Component {
  render() {
    let { className, stats, style, title, tooltipPlacement } = this.props;
    let cells = stats.map((s, key ) => {
      let position = 'mid';
      if (key === 0) position = 'first';
      if (key === stats.length -1) position = 'last';
      return (
        <StatCell key={key}
                  handleTooltip={this.props.handleTooltip}
                  data={s}
                  tooltipPlacement={tooltipPlacement}
                  position={position} />
      );
    });
  return (
    <section className={`${styles.statsTable} ${className ? className : ''} `} style={style} >
      <h6 className={styles.printTitle}>{title}</h6>
      <ul className={styles.list}>
        {cells}
      </ul>

    </section>
  );
}}

class StatCell extends React.Component {
  render() {
    let { data, position, tooltipPlacement } = this.props;

    return (
      <li
        className={styles.statCell}
        onTouchStart={(e) => { this.props.handleTooltip(e) }}
        data-rh={ data && data.alt}
        data-rh-at="bottom"
        data-rh-cls={`tooltip--${position}`} >
        <h6 className={styles.label}>{data && data.label}</h6>
        <span className={styles.value}>
          { (data && data.value === '-')
            ? '-'
            : (data.label === "Average Ticket Price")
              ? `$${numeral(data && data.value).format('0,0.00')}`
              : numeral(data && data.value).format('0,0')
          }
        </span>
      </li>
    );
}}
StatsTable.propTypes = {
  className: PropTypes.string,
  stats: PropTypes.array.isRequired,
  style: PropTypes.object,
  title: PropTypes.string.isRequired
}
StatCell.propTypes = {
  data: PropTypes.object.isRequired,
  tooltipPlacement: PropTypes.string
}

export default StatsTable;



// WEBPACK FOOTER //
// ./src/scripts/components/lib/tables/StatsTable.js